/****************************************************
 * Module Name:  pricePlanning.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class PricePlanningProxy {

    static AddPricePlanning = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/priceplanning",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static getAllPricePlanningByFilters = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/priceplanning/detail",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RefetchPricePlanningCriteria = (data, callback) => {
        restAPICall(
            Constants.UTILITY_URL + "/nivoda/stonecriteria/refetch/priceplanning",
            "put",
            undefined,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static lockDiscount = (userid, data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/priceplanning/lockdiscount/${userid}`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static deletePlansById = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/priceplanning/plan/cleanup",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
